import {
  FormHelperText,
  CheckboxProps,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Tooltip
} from '@mui/material';
import { useField } from 'formik';
import { ReactNode } from 'react';
import { CheckedIcon, DisabledCheckedIcon, DisabledUncheckedIcon, UncheckedIcon } from '../../assets/SvgIcons';

export const MFCheckbox = function ({
  label,
  name,
  onChange,
  checked,
  sx,
  ...props
}: CheckboxProps & { label?: string | JSX.Element; name: string, onHoverText?: string }): JSX.Element {
  const [field, meta] = useField(name);
  checked = checked || field.value;
  onChange = onChange || field.onChange;
  const errorText = meta.error && meta.touched ? meta.error : '';
  return (
    <FormGroup>
      <Tooltip title={props?.onHoverText || ''} arrow disableHoverListener={!props?.onHoverText}>
        <FormControlLabel
          control={
            <Checkbox
              checkedIcon={props?.disabled ? <DisabledCheckedIcon /> : <CheckedIcon />}
              icon={props?.disabled ? <DisabledUncheckedIcon /> : <UncheckedIcon />}
              {...field}
              {...props}
              checked={checked}
              onChange={onChange}
            />}
          name={name}
          label={label}
          sx={{
            '& .Mui-disabled': {
              cursor: !props.disabled ? 'pointer' : 'not-allowed !important',
              pointerEvents: 'all',
            },
            ...sx,
          }}
          componentsProps={{ typography: { variant: 'body_500' } }}
        />
      </Tooltip>

      <FormHelperText error sx={{ marginLeft: 'unset' }}>
        {errorText}
      </FormHelperText>
    </FormGroup>
  );
};

export default MFCheckbox;
